import React from "react";
import styles from "../styles/LoaderButton.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons/faSpinner";
import classnames from "classnames";

export default function LoaderButton({
  isLoading,
  disabled = false,
  onBlurCallback,
  fromClient,
  ...props
}) {
  const loaderButtonClass = classnames({
    [styles.LoaderButton]: true,
    [styles.client]: true,
  });

  const disabledClass = classnames({
    [styles.Disabled]: true,
    [styles.DisabledClient]: true,
    [styles.client]: true,
  });
  const handleOnBlur = () => {
    if (onBlurCallback) {
      onBlurCallback();
    }
  };
  return (
    <button
      type="submit"
      disabled={disabled || isLoading}
      className={disabled ? disabledClass : loaderButtonClass}
      {...props}
      onBlur={handleOnBlur}
    >
      {isLoading ? (
        <FontAwesomeIcon className={styles.loadingIcon} icon={faSpinner} spin />
      ) : (
        <span> {props.children} </span>
      )}
    </button>
  );
}
